<template>
  <div v-if="(!themeLogicCookie)">
    <div id="cookie-popup" class="cookie-consent-out-uniq">
      <p v-html="languageData['Cookie1']+' '+languageData['Cookie2']+' '+languageData['Cookie3']+' '+languageData['Cookie4']+' '+languageData['Cookie5']+' '+languageData['privacypolicy']"> </p>
      <div class="btn-align">
        <button @click="onPopupClick()" id="accept-cookies-btn" v-html="languageData['Cookie7']"></button>
      </div>    
    </div>   
  </div>
</template>

<script>
export default {
  name: 'AcceptCookiesPopup',
  data(){
      return{ 
          cookieConsent: '',
          //themeLogicCookie: this.$store.state.themeLogic.additional_flag.turn_off_cookie_pop_up
      };        
  },
  computed:{  
    languageData(){return this.$store.state.languageData;},
    themeLogicCookie(){ return this.$store.state.themeLogic.additional_flag.turn_off_cookie_pop_up;}
  },
	components:{
       
  },
  mounted(){
    var showCookie = document.getElementById('cookie-popup')
    if(localStorage.getItem("gen_cookie_consent")) {
      
      showCookie.style.display = 'none';
    }else {
        showCookie.style.display = 'block';
    }
  },
  methods:{
    onPopupClick() {
      localStorage.setItem('gen_cookie_consent',1)
      var showCookie = document.getElementById('cookie-popup')
      showCookie.style.display = 'none';
      // alert('hi')
        
    }
  }
    
};
</script>
<style scoped>
#cookie-popup {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #5a5757;
  color: white;
  padding: 1% 10%;
  text-align: left;
  z-index: 99999;
}

#accept-cookies-btn {
  background-color: #e7d320;
  color: black;
  border: none;
  padding: 6px 20px;
  border-radius: 9px;
  font-size: 16px;
  cursor: pointer;
  /* text-align: center; */
}
.btn-align {
    text-align: center;
}
@media screen and (max-width: 768px){
  #cookie-popup {
    font-size: 10px;
  }
  #cookie-popup{
    padding: 1% 3%;
  }
  #accept-cookies-btn{
    font-size: 13px;
  }
}

</style>
<style >
.cookie-consent-out-uniq a, .cookie-consent-out-uniq a:hover, .cookie-consent-out-uniq a:focus{
  color: #B0E4FF;
  text-decoration: underline;
}
</style>